import script from "./Activities.vue?vue&type=script&setup=true&lang=ts"
export * from "./Activities.vue?vue&type=script&setup=true&lang=ts"

import "./Activities.vue?vue&type=style&index=0&id=53cd53b9&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53cd53b9"]])

export default __exports__